/* --------------------------------------------------
// year
-------------------------------------------------- */
let yrmark = document.getElementById("year");
if (yrmark) {
	yrmark.innerHTML = new Date().getFullYear();
}

/* -------------------------------------------------- 
// navbar sticky style add .stickynav
-------------------------------------------------- */
window.onscroll = function () {
	navstick();
};

function navstick() {
	let headnav = document.getElementById("pghead"),
		headheight = Math.round(headnav.clientHeight);

	if (
		document.body.scrollTop > headheight ||
		document.documentElement.scrollTop > headheight ||
		window.scrollY > headheight
	) {
		headnav.classList.add("stickynav");
	} else {
		headnav.classList.remove("stickynav");
	}
}

/* -------------------------------------------------- 
// windows load and resize function
-------------------------------------------------- */
window.addEventListener("load", () => {
	backtotop();
	scrolltofn();
	workAfterResizeIsDone();
});
window.addEventListener("resize", () => {
	workAfterResizeIsDone();
});

/* -------------------------------------------------- 
// footer accordion
-------------------------------------------------- */
// timeOutFunctionId stores a numeric ID which is
// used by clearTimeOut to reset timer
var timeOutFunctionId;

function workAfterResizeIsDone() {
	// toggleFootAcc();
	// canvsize();
}

window.addEventListener("resize", () => {
	// clearTimeOut() resets the setTimeOut() timer
	// due to this the function in setTimeout() is
	// fired after we are done resizing
	clearTimeout(timeOutFunctionId);

	// setTimeout returns the numeric ID which is used by
	// clearTimeOut to reset the timer
	timeOutFunctionId = setTimeout(workAfterResizeIsDone, 300);
});

function toggleFootAcc() {
	let accords = document.querySelectorAll(".sitemap.accordion-item");

	accords.forEach(function (accord) {
		// const footacord = new bootstrap.Collapse(accord);
		let toggle = accord.querySelector(".sitemap_til");
		let menu = accord.querySelector(".accordion-collapse");

		if (window.innerWidth < 768) {
			toggle.setAttribute("data-bs-toggle", "collapse");
			// toggle.setAttribute("aria-expanded", "false");
			// menu.classList.add("collapse");
			// menu.classList.remove("show");
			// footacord.dispose();
		} else {
			// footacord.show();
			toggle.removeAttribute("data-bs-toggle");
			// toggle.setAttribute("aria-expanded", "false");
			// menu.classList.remove("collapse");
			// menu.classList.add("show");
		}
	});
}

/* --------------------------------------------------
//  basic val
-------------------------------------------------- */
var navheight = document.getElementById("pghead").clientHeight;

/* -------------------------------------------------- 
// hover indicator pos
-------------------------------------------------- */
let navitems = document.querySelectorAll(".nav-link");

navitems.forEach(function (navitem) {
	navitem.addEventListener("mouseover", hoverIndiPos);
});

function hoverIndiPos() {
	let header = document.getElementById("pghead");
	// let headH = header.clientHeight;
	let mainNav = document.getElementById("MainNav").clientHeight;
	let navWrap = document.getElementById("headH").clientHeight;
	let gap = navWrap - mainNav;
	let dropx = (navWrap - mainNav) / 2 + 1 + "px";
	let gaph = gap / 2 + "px";
	header.style.setProperty("--gaph", gaph);
	header.style.setProperty("--dropx", dropx);
} // hover indicator pos

/* --------------------------------------------------
// adjust language dropdown menu
-------------------------------------------------- */
let langtri = document.getElementById("lang_drop");
let mainNav = document.getElementById("mainav");

langtri.addEventListener("click", adjustCollapseView);

// desktop head lang drop list top position
function adjustCollapseView() {
	let headh = document.getElementById("headH").getBoundingClientRect().height,
		navh = document.getElementById("MainNav").getBoundingClientRect().height,
		lang_menu = document.getElementById("head_lang_drop"),
		marT = (headh - navh) * 0.5 - 2 + "px";

	// lang_drop.style.setProperty("--langdroph", langh);
	lang_menu.style.setProperty("--headlangdrop", marT);
}

/* -------------------------------------------------- 
// canvas menu height
-------------------------------------------------- */
/* function canvsize() {
	var menuRect = document.getElementById("pghead").getBoundingClientRect(),
		menuh = menuRect.height,
		offmar = menuh + "px",
		canvaswrapper = document.getElementById("mo_nav_canvas");

	document.body.style.setProperty("--navh", offmar);
	canvaswrapper.style.setProperty("--navh", offmar);
} */

/* --------------------------------------------------
//  back to top
-------------------------------------------------- */
function backtotop() {
	var bktps = document.querySelectorAll(".backtop");

	if (bktps.length > 0) {
		bktps.forEach(function (bktp) {
			bktp.addEventListener("click", function (e) {
				e.preventDefault();
				var scrollheight = navheight * -1;

				window.scroll({
					top: scrollheight,
					behavior: "smooth",
				});
			});
		});
	}
}

/* --------------------------------------------------
// scrollto
-------------------------------------------------- */
function scrolltofn() {
	// scroll into view
	// var scltos = document.querySelectorAll('a[href^="#"]');
	// scroll into view

	var scltos = document.querySelectorAll("data-scrollto");

	if (scltos) {
		scltos.forEach(function (sclto) {
			sclto.addEventListener("click", function (e) {
				e.preventDefault();

				var hash = this.hash,
					slideTo = document.querySelector(hash).id,
					scrollTo = document.getElementById(slideTo).offsetTop,
					winheight = window.innerHeight,
					offset = scrollTo - navheight;

				window.scroll({
					top: offset,
					behavior: "smooth",
				});

				// console.log(slideTo);
			});
		});
	}
}
